import React, { useRef, useState } from "react";
import ReactPaginate from "react-paginate";
import { useLocation, useParams, useHistory } from "react-router-dom";
import { useEffect } from "react";
import Button from "../../CommonComponent/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Records from "./Records";
import useHttp from "../../../Hooks/use-http";
import Modal from "../../../GeneratePDF/Modal";
import dayjs from "dayjs";
import HeaderFilter from "../../CommonComponent/HeaderFilter";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import { PAGINATIONBASEVALUE } from "../../../Constant";
import { useMediaQuery, Box, Paper } from "@mui/material";
import PortalTitle from "../../CommonComponent/PortalTitle";
import { usePageTitle } from "../../../Context/PageTitleContext";

// const SHIFT_TITLE = [
//   // "",
//   "Shift ID",
//   "Driver Info",
//   // "Shift Date",
//   localStorage.getItem('roleId') == '1' ? "Corp Name" : null,
//   // "Start Time",
//   // "End Time",
//   "Scheduled Time",
//   // "Started On",
//   // "Ended On",
//   "Actual Time",
//   "Shift OTP",
//   "Assigned Task",
//   "Status",
//   "Overtime",
// ].filter(Boolean);

let myClick = false;
let prev_id = "1";

let tripListFlag = 0;
let total_shift_data = [];
let today = new Date()
  .getFullYear()
  .toString()
  .concat("-", new Date().getMonth() + 1, "-", new Date().getDate());
let startDate = today;
let endDate = today;

function Shifts(props) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  let staffMoNumber = queryParams.get("staff");

  const [currentPage, setCurrentPage] = useState(1);
  // const [recordsPerPage] = useState(7);
  const [filteredData, setFilteredData] = useState(total_shift_data);
  // const [mainData1, setMainData1]=useState(null)

  const [isDataFiltered, setIsDataFiltered] = useState(true);
  const [isExportButtonClicked, setIsExportButtonClicked] = useState(false);
  const [isSnackbarShow, setIsSnackbarShow] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const startDateRef = useRef();
  const endDateRef = useRef();
  const history = useHistory();
  const [startDateValue, setStartDateValue] = useState(dayjs(new Date()));
  const [endDateValue, setEndDateValue] = useState(dayjs(new Date()));
  const [corporateData, setCorporateData] = useState([]);
  const [corporateID, setCorporateID] = useState(null);
  const [statusCount, setStatusCount] = useState({
    pending: 0,
    started: 0,
    ended: 0,
    cancelled: 0,
  });
  const [selectedCorporateDetails, setSelectedCorporateDetails] =
    useState(null);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(PAGINATIONBASEVALUE);
  const isMobile = useMediaQuery("(max-width:768px)");

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const [roleId, setRoleId] = useState(localStorage.getItem("roleId"));
  const { setPageTitle } = usePageTitle();

  useEffect(() => {
    const handleStorageChange = () => {
      setRoleId(localStorage.getItem("roleId"));
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  // Set the correct page title when component mounts
  useEffect(() => {
    setPageTitle("Shifts");
  }, [setPageTitle]);

  const SHIFT_TITLE = [
    "Shift ID",
    "Driver Info",
    roleId === "1" ? "Corp Name" : null,
    "Scheduled Time",
    "Actual Time",
    "Shift Location",
    "Assigned Task",
    "Status",
    // "",
    // "Overtime",
  ].filter(Boolean);

  //   Function for the handlesearch
  const handleSearchInputChange = (e) => {
    setSearchValue(e.target.value);
  };

  const overtimeUpdateSuccessHandler = (details) => {
    // console.log(details);
    setIsDataFiltered(true);
    setIsSnackbarShow(details);
  };

  const authenticateUser = (data) => {
    let shift_list = [];

    if (data?.shifts) {
      for (let i = 0; i < data?.shifts.length; i++) {
        shift_list.push({
          id: i + 1,
          driver_name:
            data?.shifts[i].driver?.fName + " " + data?.shifts[i].driver?.lName,
          car_info:
            data?.shifts[i].driver?.vehicle?.model +
            "," +
            data?.shifts[i].driver?.vehicle?.regNumber,
          shift_id: data?.shifts[i].shiftID,
          // shift_date: data?.shift[i].StartTime.split("T")[0],
          shift_startTime: data?.shifts[i].startTime.replace("T", " "),
          shift_endTime: data?.shifts[i].endTime.replace("T", " "),
          shift_startedOn: data?.shifts[i].startedOn,
          shift_endedOn: data?.shifts[i].endedOn,
          reporting_location: data?.shifts[i].startLocation,
          reporting_latLng: data?.shifts[i].startLL,
          end_location: data?.shifts[i].endLocation,
          end_latLng: data?.shifts[i].endLL,
          status: data?.shifts[i]?.status,
          corporate: data?.shifts[i]?.corporate?.name,
          overTime: data?.shifts[i].overTime,
          // approvedTime: data?.shifts[i].ApprovedTime,
          taskNames: data?.shifts[i]?.taskNames,
          shiftId: data?.shifts[i].shiftID,
          // completedTask: data?.shift[i].CompletedTask,
          corporateName: data?.shifts[i].parentName, //need to see
          startOtp: data?.shifts[i].startOtp,
          endOtp: data?.shifts[i].endOtp,
          startOtpEnable: data?.shifts[i].isStartOtpEnable,
          endOtpEnable: data?.shifts[i].isEndOtpEnable,
          model: data?.shifts[i].driver?.vehicle?.Model,
          completedTask: data?.shifts[i]?.completedTask,
          cancelledOn: data?.shifts[i]?.cancelledOn,
          cancelledBy: data?.shifts[i]?.cancelledBy,
          cancelReason: data?.shifts[i]?.cancelReason,
          startLocation: data?.shifts[i]?.startLocation,
          endLocation: data?.shifts[i]?.endLocation,
          startLL: data?.shifts[i]?.startLL,
          endLL: data?.shifts[i]?.endLL,
          regNumber: data?.shifts[i]?.regNumber,
          model: data?.shifts[i]?.vehicle?.model,
        });
      }
    }
    total_shift_data = shift_list;
    setFilteredData(shift_list);
    setIsDataFiltered(false);
  };

  const { isLoading, sendRequest } = useHttp();
  const roleIdLocal = localStorage.getItem("roleId");
  useEffect(() => {
    if (isDataFiltered) {
      setFilteredData([]);

      const formatDate = (date, time) => {
        // Ensure the input is a Date object or a valid ISO string
        if (date instanceof Date) {
          // If it's a Date object, extract the date part
          const year = date.getFullYear();
          const month = (date.getMonth() + 1).toString().padStart(2, "0");
          const day = date.getDate().toString().padStart(2, "0");
          return `${year}-${month}-${day}T${time}Z`; // Append the desired time
        } else if (typeof date === "string") {
          // If it's already a string in ISO format
          const [datePart] = date.split("T");
          return `${datePart}T${time}Z`; // Append the desired time
        }
        return date; // Return as is if not a Date or string
      };

      sendRequest(
        {
          url: "/shifts",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
            data: {
              filter: {
                corporateID: selectedCorporateDetails
                  ? selectedCorporateDetails[0]?.cpId
                  : localStorage.getItem("roleId") != "1"
                  ? localStorage.getItem("corpId")
                    ? localStorage.getItem("corpId")
                    : ""
                  : "",

                startDate: `${startDateValue.$d.getFullYear()}/${
                  startDateValue.$d.getMonth() + 1
                }/${startDateValue.$d.getDate()}`,
                endDate: `${endDateValue.$d.getFullYear()}/${
                  endDateValue.$d.getMonth() + 1
                }/${endDateValue.$d.getDate()}`,
              },
            },
          },
        },
        authenticateUser
      );
    }
  }, [sendRequest, isDataFiltered, searchValue]);

  // Function to handle corporate selection change
  const handleCorporateSelect = (selectedCorporateID) => {
    setCorporateID(selectedCorporateID);
  };

  const nPages = Math.ceil(filteredData.length / rowsPerPage);

  let fromRecords = 0;
  // if (currentPage === 1) fromRecords = 1;
  if (page === 0) fromRecords = 1;
  // else fromRecords = (currentPage - 1) * rowsPerPage;
  else fromRecords = page * rowsPerPage;

  let toRecords = 0;
  if (
    (myClick
      ? page * rowsPerPage - (filteredData.length % rowsPerPage)
      : page * rowsPerPage +
        rowsPerPage -
        (filteredData.length % rowsPerPage)) > filteredData.length
  )
    toRecords = filteredData.length;
  else toRecords = page * rowsPerPage;
  if (toRecords === 0) fromRecords = 0;
  if (page === nPages) toRecords = filteredData.length;

  // Calculate pagination
  const indexOfLastRecord = page * rowsPerPage + rowsPerPage;
  const indexOfFirstRecord = page * rowsPerPage;
  const currentRecords = filteredData.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  useEffect(() => {
    if (filteredData) {
      let pending = 0;
      let started = 0;
      let ended = 0;
      let cancelled = 0;

      filteredData.forEach((item) => {
        if (item.cancelledOn != null) {
          cancelled++;
        } else if (item.shift_startedOn != null && item.shift_endedOn != null) {
          ended++;
        } else if (item.shift_startedOn != null && item.shift_endedOn == null) {
          started++;
        } else if (item.shift_startedOn == null && item.shift_endedOn == null) {
          pending++;
        }
      });

      setStatusCount({
        pending,
        started,
        ended,
        cancelled,
      });
    }
  }, [total_shift_data]);

  return (
    <>
      <Snackbar
        open={isSnackbarShow}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={() => setIsSnackbarShow(false)}
      >
        <Alert
          onClose={() => setIsSnackbarShow(false)}
          severity={isSnackbarShow.type}
          sx={{ width: "100%" }}
        >
          {isSnackbarShow.message}
        </Alert>
      </Snackbar>
      <div className="trips-details" id="trip-table">
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          marginTop: 0,
          paddingTop: 0,
        }}
      >
          <div className="table-container" style={{ marginTop: 0, paddingTop: 0 }}>
          
              <Box
                sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
                  px: 2,
                  pt: 1,
                  pb: 1,
                  borderRadius: "10px",
                  flexDirection: { xs: "column", md: "row" },
                  gap: { xs: 1, md: 0 },
          }}
        >
                <Box component="h2" sx={{ m: 0, display: "flex", alignItems: "center" }}>
          <PortalTitle fallback="Shifts" />
                </Box>
                <Box
            sx={{
                    display: "flex",
                    gap: "12px",
                    alignItems: "center",
                    flexDirection: { xs: "column", md: "row" },
                  }}
                >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <HeaderFilter
                    enableCorporateFilter={true}
                    enableDateFilter={true}
                    enableSearchFilter={true}
                    isShiftData={true}
                    mainData={total_shift_data}
                    selectedCorporate={selectedCorporateDetails}
                    setSelectedCorporate={setSelectedCorporateDetails}
                    corporateData={corporateData}
                    setCorporateData={setCorporateData}
                    setFilteredData={setFilteredData}
                    filteredData={filteredData}
                    onCorporateSelect={handleCorporateSelect}
                    setIsRefreshCorporate={setIsDataFiltered}
                    startDateValue={startDateValue}
                    endDateValue={endDateValue}
                    setStartDateValue={setStartDateValue}
                    setEndDateValue={setEndDateValue}
                    setIsRefereshData={setIsDataFiltered}
                    data={total_shift_data}
                    searchValue={searchValue}
                    setSearchValue={setSearchValue}
                    setSearchFilteredData={setFilteredData}
                  />
                  </LocalizationProvider>
                  <Button
                    variant="outlined"
                    sx={{
                      color: "#1D85C6",
                      border: "1px solid #1D85C6",
                      ":hover": {
                        border: "1px solid #1D85C6",
                        color: "black",
                      },
                    }}
                    size="small"
                    onClick={() => setIsExportButtonClicked(true)}
                  >
                    Export
                  </Button>
                  <Button
                    onClick={() => history.push("/privatedrive/shift-creation")}
                    variant="contained"
                    size="medium"
                    sx={{
                      backgroundColor: "#44B150",
                      ":hover": {
                        backgroundColor: "#44B150",
                        opacity: 0.8,
                      },
                      boxShadow: "none",
                      fontFamily: "Montserrat",
                      fontSize: "12px",
                      padding: "8px 20px",
                      textTransform: "none",
                      minWidth: "100px",
                    }}
                  >
                    {isMobile ? "Add Shift" : "Add Shift"}
                    </Button>
                </Box>
              </Box>
          <Records
            // data={currentRecords}
            data={total_shift_data}
            filteredData={filteredData}
            headers={SHIFT_TITLE}
            isLoading={isLoading}
            setIsDataFiltered={setIsDataFiltered}
            overtimeUpdateSuccessHandler={overtimeUpdateSuccessHandler}
          />
            
        </div>
        </Box>
        {isExportButtonClicked && (
          <>
            <Modal
              setIsExportButtonClicked={setIsExportButtonClicked}
              isPrivateDriver="1"
              isShift="1"
              type="shifts"
            />
            <div className="add-route-fullcontainer"></div>
          </>
        )}
      </div>
    </>
  );
}

export default Shifts;
